import propertyimage1 from '../images/l1.jpeg'
import propertyimage2 from '../images/l2.png'
import propertyimage3 from '../images/l3.jpeg'
import propertyimage4 from '../images/l4.jpeg'
import propertyimage5 from '../images/LISTING-2.png'
import propertyimage6 from '../images/l6.png'
import propertydownimage1 from '../images/LISTING-1.png'
import propertydownimage2 from '../images/LISTISG-3.png'
import jigwoyi from '../images/sarinawa.jpg'
import pwan from '../images/land-2.png'
import digiforte from '../images/digiforte.png'
import gwagwalada20 from '../images/gwagwalada 20m.jpg'
import rentshop from '../images/rent shop.jpg'
export const exploreItems=[
  {
    id: 1,
    type: "Land",
    location: "Off constitution Avenue, Central Business District Abuja",
    price: 'Premium',
    title: "3300sqm of land",
    shortDescription: "3300sqm of prime commercial land.",
    image: propertyimage1,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%203300sqm%20of%20land%20Off%20Constitution%20Avenue%2C%20Central%20Business%20District%20Abuja"
  },
  {
    id: 2,
    type: "Terraced Duplex (One Unit left)",
    location: "Guzape, Abuja",
    price: '250M',
    title: "Terraced duplex (one unit)",
    shortDescription: "25sqm shops for rent",
    image: propertyimage2,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%20Terraced%20duplex%20(one%20unit)%20in%20Guzape%2C%20Abuja"
  },
  {
    id: 3,
    type: "Land",
    location: "Kenneth Imansuagbon Street Guzape District, Abuja.",
    price: "Premium",
    title: "1300sqm prime residential land",
    shortDescription: "3,3,300sqm land size",
    image: propertyimage3,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%201300sqm%20prime%20residential%20land%20at%20Kenneth%20Imansuagbon%20Street%2C%20Guzape%20District%2C%20Abuja"
  },
  {
    id: 4,
    type: "Land",
    location: "Lokogoma, Abuja.",
    price: '750M',
    title: "3,400sqm Prime commercial plot",
    shortDescription: "-Fenced and Paved with interlockings, -it has hall of various sizes around the perimeter available for rents",
    image: propertyimage4,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%203400sqm%20Prime%20commercial%20plot%20in%20Lokogoma%2C%20Abuja"
  },
  {
    id: 5,
    type: "Residential",
    location: "Sil Estate, Mbora, Abuja",
    price: '180M',
    title: "1000sqm land",
    shortDescription: "1000sqm land area.",
    image: propertyimage5,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%201000sqm%20land%20in%20Sil%20Estate%2C%20Mbora%2C%20Abuja"
  },
  {
    id: 6,
    type: "Land",
    location: "Digiforte Estate Lugbe, Abuja",
    price: '10M(Each)',
    title: "2 plots of 500sqm each",
    shortDescription: "2 plot of 500sqm land.",
    image: digiforte,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%202%20plots%20of%20500sqm%20each%20at%20Digiforte%20Estate%2C%20Lugbe%2C%20Abuja"
  },
]
export const listingItems = [
  {
    id: 1,
    type: "Land",
    location: "Off constitution Avenue, Central Business District Abuja",
    price: 'Premium',
    title: "3300sqm of land",
    shortDescription: "3300sqm of prime commercial land.",
    image: propertyimage1,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%203300sqm%20of%20land%20Off%20Constitution%20Avenue%2C%20Central%20Business%20District%20Abuja"
  },
  {
    id: 2,
    type: "Terraced Duplex (One Unit left)",
    location: "Guzape, Abuja",
    price: '250M',
    title: "Terraced duplex (one unit)",
    shortDescription: "25sqm shops for rent",
    image: propertyimage2,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%20Terraced%20duplex%20(one%20unit)%20in%20Guzape%2C%20Abuja"
  },
  {
    id: 3,
    type: "Land",
    location: "Kenneth Imansuagbon Street Guzape District, Abuja.",
    price: "Premium",
    title: "1300sqm prime residential land",
    shortDescription: "3,3,300sqm land size",
    image: propertyimage3,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%201300sqm%20prime%20residential%20land%20at%20Kenneth%20Imansuagbon%20Street%2C%20Guzape%20District%2C%20Abuja"
  },
  {
    id: 4,
    type: "Land",
    location: "Lokogoma, Abuja.",
    price: '750M',
    title: "3,400sqm Prime commercial plot",
    shortDescription: "-Fenced and Paved with interlockings, -it has hall of various sizes around the perimeter available for rents",
    image: propertyimage4,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%203400sqm%20Prime%20commercial%20plot%20in%20Lokogoma%2C%20Abuja"
  },
  {
    id: 5,
    type: "Residential",
    location: "Sil Estate, Mbora, Abuja",
    price: '180M',
    title: "1000sqm land",
    shortDescription: "1000sqm land area.",
    image: propertyimage5,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%201000sqm%20land%20in%20Sil%20Estate%2C%20Mbora%2C%20Abuja"
  },
  {
    id: 6,
    type: "Land",
    location: "Digiforte Estate Lugbe, Abuja",
    price: '10M(Each)',
    title: "2 plots of 500sqm each",
    shortDescription: "2 plot of 500sqm land.",
    image: propertyimage6,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%202%20plots%20of%20500sqm%20each%20at%20Digiforte%20Estate%2C%20Lugbe%2C%20Abuja"
  },
  {
  id: 7,
  type: "Land",
  location: "Gwagwalada, Abuja",
  price: "N20M",
  title: "1000SQM of Residential Land",
  shortDescription: "3300sqm of prime commercial land",
  image: gwagwalada20, // replace with correct image import
  link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%201000sqm%20Residential%20Land%20in%20Gwagwalada%2C%20Abuja"
},
{
  id: 8,
  type: "Land",
  location: "Jigwoyi City Estate Sarinawa, Junction, Abuja",
  price: "N6M",
  title: "500SQM Land",
  shortDescription: "2 plot of 500sqm land",
  image: jigwoyi, // replace with correct image import
  link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%20500sqm%20Land%20at%20Jigwoyi%20City%20Estate%2C%20Abuja"
},
{
  id: 9,
  type: "Shop",
  location: "Mogadishu Cantonment Market (new extension)",
  price: "N600k",
  title: "2 Ensuite Shops for Rent",
  shortDescription: "2 ensuite shops available for rent at Mogadishu Cantonment Market.",
  image: rentshop, // replace with correct image import
  link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%202%20ensuite%20shops%20for%20rent%20at%20Mogadishu%20Cantonment%20Market"
}, 
{id: 10,
    type: "Residential",
    location: "Karu Street, Abuja",
    price: "N20M",
    title: "3 Bedroom Bungalow with BQ",
    shortDescription: "3-bedroom bungalow with 1 BQ located in Karu, Abuja.",
    image: propertydownimage1,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I'm%20interested%20in%20the%203%20Bedroom%20Bungalow%20with%20BQ%20at%20Karu%20Street%2C%20Abuja"
  },
  {
    id: 11,
    type: "Residential",
    location: "Lugbe FHA, Abuja",
    price: "N85M",
    title: "3 Bedroom Bungalow with 2 Rooms BQ",
    shortDescription: "Spacious 3-bedroom bungalow with 2-room BQ in Lugbe FHA, Abuja.",
    image: propertydownimage2,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I'm%20interested%20in%20the%203%20Bedroom%20Bungalow%20with%202%20Rooms%20BQ%20at%20Lugbe%20FHA%2C%20Abuja"
  },{
  id: 12,
  type: "Land",
  location: "(PWAN) Estate Gwagwalada, Abuja",
  price: "N10M",
  title: "500SQM Land",
  shortDescription: "500SQM Land Area",
  image: pwan,
  link: "https://wa.me/2348085312366?text=Hello%20there!%20I%20want%20to%20make%20enquiry%20about%20the%20500SQM%20land%20at%20(PWAN)%20Estate%2C%20Gwagwalada%2C%20Abuja"
}
];
























export const DownItems = [
  {
    id: 1,
    type: "Residential",
    location: "Karu Street, Abuja",
    price: "N20M",
    title: "3 Bedroom Bungalow with BQ",
    shortDescription: "3-bedroom bungalow with 1 BQ located in Karu, Abuja.",
    image: propertydownimage1,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I'm%20interested%20in%20the%203%20Bedroom%20Bungalow%20with%20BQ%20at%20Karu%20Street%2C%20Abuja"
  },
  {
    id: 2,
    type: "Residential",
    location: "Lugbe FHA, Abuja",
    price: "N85M",
    title: "3 Bedroom Bungalow with 2 Rooms BQ",
    shortDescription: "Spacious 3-bedroom bungalow with 2-room BQ in Lugbe FHA, Abuja.",
    image: propertydownimage2,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I'm%20interested%20in%20the%203%20Bedroom%20Bungalow%20with%202%20Rooms%20BQ%20at%20Lugbe%20FHA%2C%20Abuja"
  },
  {
    id: 3,
    type: "Residential",
    location: "Sil Estate, Mbora, Abuja",
    price: "N180M",
    title: "2 Living Room Duplex",
    shortDescription: "Luxury duplex with 2 living rooms and 4 bedrooms located in Sil Estate, Mbora.",
    image: propertyimage5,
    link: "https://wa.me/2348085312366?text=Hello%20there!%20I'm%20interested%20in%20the%202%20Living%20Room%20Duplex%20at%20Sil%20Estate%2C%20Mbora%2C%20Abuja"
  }
];
